import {
  Encerramento,
  getEncerramento,
  updateEncerramento,
  updateEncerramentoComArquivo,
  iniciarProcessoEncerramento,
  urlDownloadEncerramento,
  removerArquivoEncerramento,
  iniciarAdicao,
  updateObservacao,
} from '@app/api/contrato/encerramento';
import * as Yup from 'yup';
import {
  CrudContext,
  FormatText,
  FormInput,
  FormSubmitButton,
  FormTextArea,
  MasterDetailForm,
  usePromise,
  Widget,
  Button,
  FormDatePicker,
  FormSwitch,
} from '@digital/ui';
import Title from 'antd/lib/typography/Title';
import React, { useContext, useEffect, useState } from 'react';
import FormContratoUpload from './FormContratoUpload';
import { Collapse, Icon, Col, Row, Modal } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import { fixedEncodeURIComponent } from '@app/helpers/stringHelper';
import { url } from 'inspector';
import { Notifiable } from '@app/types/core.types';
import { hasNotification } from '@app/utils/notificationUtils';
import { ModalInclusaoMultAnexo } from '@app/components';

export const initialValuesEncerramento: Encerramento = {
  id: '',
  contratoId: '',
  statusEncerramento: '',

  observacaoNadaConsta: '',
  observacaoTEQCAssinado: '',
  observacaoTRD: '',
  observacaoTRP: '',
};

const { Panel } = Collapse;

const AbaEncerramento = () => {
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const [modalConfirmarEncerramentoMedicaoCancelada, setModalConfirmarEncerramentoMedicaoCancelada] = useState(false);

  const { selectedItem } = useContext(CrudContext);
  const [encerramentoData] = usePromise<Encerramento>(
    () => (selectedItem ? getEncerramento(selectedItem.id) : Promise.resolve({} as Encerramento)),
    [selectedItem, shouldUpdate],
    {} as Encerramento,
  );

  const [statusCodigo, setStatusCodigo] = useState();
  const [dataEcerramento, setDataEcerramento] = useState();

  useEffect(() => {
    setStatusCodigo(encerramentoData.statusEncerramentoCodigo);
    setDataEcerramento(encerramentoData);
  }, [encerramentoData]);

  const handleIniciarProcessoEncerramento = () =>
    selectedItem &&
    iniciarProcessoEncerramento(selectedItem.id)
      .then((resp: any) => {

        if (hasNotification(resp.notifications, 'MsgNaoPodeIniciarEncerramentoContratoSemBMMarcadoComoFinal')) {
          Modal.confirm({
            title: 'Iniciar Encerramento',
            content: 'Deseja prosseguir com a ação? o BM marcado como final se encontra ‘Cancelado’.',
            cancelText: 'Não',
            onCancel: () => { },
            okText: 'Sim',
            onOk: () => {
              setModalConfirmarEncerramentoMedicaoCancelada(true);
            },
          });
        }

        if (resp.valid) {
          document.location.reload();
        }

      });

  const handleUpload = (codigoSolicitacao: number) => (values: any) => {
    updateEncerramentoComArquivo(values.formData, values, codigoSolicitacao).then(resp => {
      if (resp.valid) {
        setShouldUpdate(false);
        setShouldUpdate(true);
      }
    });
  };

  const handleRemoveFile = (codigoSolicitacao: number) => (values: any) => {
    removerArquivoEncerramento(selectedItem.id, codigoSolicitacao).then(resp => {
      if (resp.valid) {
        getEncerramento(selectedItem.id).then(result => {
          setDataEcerramento(result);
        });
      }
    });
  };

  const handleContratoSeraAditado = () => {
    if (selectedItem) {
      iniciarAdicao(selectedItem.id).then(resp => {
        if (resp.valid) {
          document.location.reload();
        }
      });
    }
  };

  const handleUpdateObservacao = value => {
    if (selectedItem) {
      updateObservacao({ id: selectedItem.id, observacao: value }).then(resp => setShouldUpdate(!shouldUpdate));
    }
  };

  return (
    <>
      <MasterDetailForm initialValues={dataEcerramento}>
        <Widget
          title="Processo de Encerramento de Contrato"
          actions={[
            dataEcerramento &&
              (dataEcerramento.seraAditado === false || dataEcerramento.seraAditado === undefined) &&
              dataEcerramento.statusEncerramentoCodigo == 1 &&
              hasPermission(['CONTRATO_ENCERRAMENTO_SERA_ADITADO']) ? (
              <Button type="primary" onClick={handleContratoSeraAditado}>
                CONTRATO SERÁ ADITADO
              </Button>
            ) : (
              <></>
            ),
            statusCodigo == 1 && hasPermission(['CONTRATO_ENCERRAMENTO_INICIAR']) ? (
              <Button type="primary" onClick={handleIniciarProcessoEncerramento}>
                Iniciar Encerramento
              </Button>
            ) : (
              <></>
            ),
          ]}>
          <FormInput label="Status Atual" name="statusEncerramento" span={3} disabled />
          <FormInput
            label="Processo de encerramento autorizado por"
            name="responsavelInicioEncerramento"
            span={3}
            disabled
          />
          <FormDatePicker
            format="DD/MM/YYYY HH:mm"
            label="Data de Início"
            name="dataHoraInicioProcesso"
            span={3}
            disabled
          />
          <FormDatePicker
            format="DD/MM/YYYY HH:mm"
            label="Encerramento TOTVS"
            name="dataHoraEncerramentoProcesso"
            span={3}
            disabled
          />

          {dataEcerramento && dataEcerramento.seraAditado ? (
            <>
              <FormInput label="Processo de aditivo informado por" name="responsavelAdicao" disabled span={3} />
              <FormDatePicker
                format="DD/MM/YYYY HH:mm"
                label="Data da informação"
                name="dataInicioAdicao"
                disabled
                span={3}
              />
            </>
          ) : (
            <></>
          )}
          {hasPermission(['CONTRATO_ENCERRAMENTO_OBSERVACAO']) ? (
            <FormTextArea
              label="Observação de Encerramento"
              name="observacao"
              span={12}
              rows={3}
              onPressEnter={event => handleUpdateObservacao(event.currentTarget.value)}
              disabled={!hasPermission(['CONTRATO_ENCERRAMENTO_OBSERVACAO'])}
            />
          ) : (
            <></>
          )}
        </Widget>
      </MasterDetailForm>
      {statusCodigo != 1 ? (
        <>
          {encerramentoData.localArquivoTRP ? (
            <Collapse bordered={false} defaultActiveKey={['TRP']} expandIcon={() => <Icon type="arrows-right_4" />}>
              <Panel key="TRP" header={<span>TRP - Termo de Recebimento Provisório</span>} style={{ border: 0 }}>
                <MasterDetailForm
                  onSubmit={handleUpload(1)}
                  initialValues={dataEcerramento}
                  validationSchema={Yup.object().shape({
                    observacaoTRP: Yup.string().max(2000, 'O campo observação deve ter no máximo 2000 caracteres.'),
                  })}>
                  <Widget
                    actions={[
                      hasPermission(['CONTRATO_ENCERRAMENTO_ANEXAR_TRP_TRD']) && (
                        <FormSubmitButton
                          noIcon={true}
                          type="primary"
                          disabled={statusCodigo == 1 || statusCodigo == 9}>
                          <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                      ),
                    ]}>
                    <FormDatePicker format="DD/MM/YYYY" label="Data do Upload" name="dataUploadTRP" span={6} disabled />
                    <FormInput label="Responsável" name="responsavelTRP" span={6} disabled />
                    <FormTextArea label="Observações" name="observacaoTRP" span={12} rows={6} />
                    <FormContratoUpload
                      onRemove={handleRemoveFile(1)}
                      fileName={encerramentoData.nomeArquivoTRP}
                      url={
                        urlDownloadEncerramento +
                        encerramentoData.localArquivoTRP +
                        '\\' +
                        encerramentoData.nomeArquivoTRP +
                        '&fileName=' +
                        encerramentoData.nomeArquivoTRP
                      }
                      disabled
                    />
                  </Widget>
                </MasterDetailForm>
              </Panel>
            </Collapse>
          ) : (
            <></>
          )}

          {encerramentoData.localArquivoTRD ? (
            <Collapse bordered={false} defaultActiveKey={['TRD']} expandIcon={() => <Icon type="arrows-right_4" />}>
              <Panel
                key="TRD"
                header={<span>TRD – Termo de Recebimento Definitivo / Anuência da área gestora</span>}
                style={{ border: 0 }}>
                <MasterDetailForm
                  onSubmit={handleUpload(2)}
                  initialValues={dataEcerramento}
                  validationSchema={Yup.object().shape({
                    observacaoTRD: Yup.string().max(2000, 'O campo observação deve ter no máximo 2000 caracteres.'),
                  })}>
                  <Widget
                    actions={[
                      hasPermission(['CONTRATO_ENCERRAMENTO_ANEXAR_TRP_TRD']) && (
                        <FormSubmitButton
                          noIcon={true}
                          type="primary"
                          disabled={statusCodigo == 1 || statusCodigo == 9}>
                          <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                      ),
                    ]}>
                    <FormDatePicker format="DD/MM/YYYY" label="Data do Upload" name="dataUploadTRD" span={6} disabled />
                    <FormInput label="Responsável" name="responsavelTRD" span={6} disabled />
                    <FormTextArea label="Observações" name="observacaoTRD" span={12} rows={6} />
                    <FormContratoUpload
                      onRemove={handleRemoveFile(2)}
                      fileName={encerramentoData.nomeArquivoTRD}
                      url={
                        urlDownloadEncerramento +
                        encerramentoData.localArquivoTRD +
                        '\\' +
                        encerramentoData.nomeArquivoTRD +
                        '&fileName=' +
                        encerramentoData.nomeArquivoTRD
                      }
                      disabled
                    />
                  </Widget>
                </MasterDetailForm>
              </Panel>
            </Collapse>
          ) : (
            <></>
          )}

          <Collapse
            bordered={false}
            defaultActiveKey={['nadaConsta']}
            expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel key="nadaConsta" header={<span>Nada Consta</span>} style={{ border: 0 }}>
              <MasterDetailForm
                onSubmit={handleUpload(3)}
                initialValues={dataEcerramento}
                validationSchema={Yup.object().shape({
                  observacaoNadaConsta: Yup.string().max(
                    2000,
                    'O campo observação deve ter no máximo 2000 caracteres.',
                  ),
                })}>
                <Widget
                  actions={[
                    hasPermission(['CONTRATO_ENCERRAMENTO_ANEXAR_NADA_CONSTA']) && (
                      <FormSubmitButton noIcon={true} type="primary" disabled={statusCodigo == 1 || statusCodigo == 9}>
                        <FormatText id="ui.commons.save" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormDatePicker
                    format="DD/MM/YYYY"
                    label="Data do Upload"
                    name="dataUploadNadaConsta"
                    span={6}
                    disabled
                  />
                  <FormInput label="Responsável" name="responsavelNadaConsta" span={6} disabled />
                  <FormTextArea label="Observações" name="observacaoNadaConsta" span={12} rows={6} />
                  <FormContratoUpload
                    onRemove={handleRemoveFile(3)}
                    fileName={encerramentoData.nomeArquivoNadaConsta}
                    url={
                      urlContrato(encerramentoData.nomeArquivoNadaConsta, encerramentoData.localArquivoNadaConsta)
                    }
                  />
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
          <Collapse
            bordered={false}
            defaultActiveKey={['TEQCAssinado']}
            expandIcon={() => <Icon type="arrows-right_4" />}>
            <Panel key="TEQCAssinado" header={<span>TEQC Assinado</span>} style={{ border: 0 }}>
              <MasterDetailForm
                onSubmit={handleUpload(4)}
                initialValues={dataEcerramento}
                validationSchema={Yup.object().shape({
                  observacaoTEQCAssinado: Yup.string().max(
                    2000,
                    'O campo observação deve ter no máximo 2000 caracteres.',
                  ),
                })}>
                <Widget
                  actions={[
                    hasPermission(['CONTRATO_ENCERRAMENTO_ANEXAR_TEQC_ASSINADO']) && (
                      <FormSubmitButton noIcon={true} type="primary" disabled={statusCodigo == 1 || statusCodigo == 9}>
                        <FormatText id="ui.commons.save" uppercase />
                      </FormSubmitButton>
                    ),
                  ]}>
                  <FormDatePicker
                    format="DD/MM/YYYY"
                    label="Data do Upload"
                    name="dataUploadTEQCAssinado"
                    span={6}
                    disabled
                  />
                  <FormInput label="Responsável" name="responsavelTEQCAssinado" span={6} disabled />
                  <FormTextArea label="Observações" name="observacaoTEQCAssinado" span={12} rows={6} />
                  <Row>
                    <Col span={6}>
                      <FormContratoUpload
                        onRemove={handleRemoveFile(4)}
                        fileName={encerramentoData.nomeArquivoTEQCAssinado}
                        url={
                          urlContrato(encerramentoData.nomeArquivoTEQCAssinado, encerramentoData.localArquivoTEQCAssinado)
                        }
                      />
                    </Col>
                    <Col span={6}>
                      <FormSwitch label="Seguir encerramento sem TEQC" name="encerramentoSemTeqc" span={12} />
                    </Col>
                    <Col span={12}>
                      <FormInput label="Justificativa do Encerramento sem TEQC" name="justificativaEncerramentoSemTeqc" span={12} />
                    </Col>
                  </Row>
                </Widget>
              </MasterDetailForm>
            </Panel>
          </Collapse>
        </>
      ) : (
        <></>
      )}

      <ModalInclusaoMultAnexo
        onlyModal={true}
        onlyModalOpenController={modalConfirmarEncerramentoMedicaoCancelada}
        onChangeOpen={setModalConfirmarEncerramentoMedicaoCancelada}
        buttonIcon="commons-plus"
        buttonTooltip='Iniciar Encerramento'
        onSubmit={async (values) => {

          iniciarProcessoEncerramento(selectedItem.id, values.justificativa)
            .then((resp: any) => {
              if (resp.valid) {
                document.location.reload();
              }
            });

        }}
        showJustificativa
        isJustificativaInput
        textButtonSave="Salvar"
        showUploadArquivos={false}
      />
    </>
  );

  function urlContrato(fileName: any, local: any): string | undefined {
    var urlContrato = urlDownloadEncerramento +
      fixedEncodeURIComponent(local as string) +
      '\\' +
      fixedEncodeURIComponent(fileName as string) +
      '&fileName=' +
      fixedEncodeURIComponent(fileName as string);

    return urlContrato;
  }
};

export default AbaEncerramento;
